import { useEffect } from "react";
import { Shell } from "./shell/Shell.js";
import { useStore } from "./state/store.js";

export function App() {
  const boot = useStore((s) => s.boot);
  const sessionLoaded = useStore((s) => s.sessionLoaded);

  useEffect(() => {
    void boot();
  }, [boot]);

  // Nothing paints until the session answer is in: rendering the front door
  // to a signed-in user (or the shell to a signed-out one) and then
  // swapping is worse than a beat of empty glass.
  if (!sessionLoaded) return null;

  return <Shell />;
}
